import { css } from "@compiled/react";
import { defineMessages, useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

import type { MessageDescriptor } from "react-intl";

type Props = {
    ctaText: MessageDescriptor;
    generalCtaLink?: string;
    specificCtaLink: string;
};

const containerCss = css({
    margin: "0 auto",
    padding: "16px",
    textAlign: "center",
    width: "66.66%",
    h2: {
        color: "#253858",
        fontFamily: "Charlie Display",
        fontSize: "2.25rem",
        fontWeight: 500,
        letterSpacing: 0,
        lineHeight: 1.33333333,
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        marginBottom: "24px",
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        marginTop: 0
    },
    p: {
        fontSize: "1rem",
        lineHeight: 1.5
    },
    a: {
        color: "#0052cc",
        textDecoration: "underline"
    }
});

const QuestionsCta = ({ ctaText, generalCtaLink, specificCtaLink }: Props) => {
    const intl = useIntl();
    const messages = defineMessages({
        questionsHeader: {
            id: "QuestionsCtaPattern.questionsHeader",
            defaultMessage: "Questions?"
        }
    });

    const localizedGeneralCtaLink = useLocalizedHref(
        generalCtaLink || "/licensing/cloud#users-roles"
    );
    const localizedSpecificCtaLink = useLocalizedHref(specificCtaLink);

    return (
        <Row>
            <div css={containerCss}>
                <h2>{intl.formatMessage(messages.questionsHeader)}</h2>
                <p>
                    {intl.formatMessage(ctaText, {
                        generalCta: (chunks: React.ReactNode) => (
                            <a href={localizedGeneralCtaLink}>{chunks}</a>
                        ),
                        specificCta: (chunks: React.ReactNode) => (
                            <a href={localizedSpecificCtaLink}>{chunks}</a>
                        )
                    })}
                </p>
            </div>
        </Row>
    );
};

export default QuestionsCta;
